export { default as About } from './About';
export { default as AccessDenied } from './AccessDenied';
export * from './AddEntity';
export { default as AdditionalEntityVerificationPrompt } from './AdditionalEntityVerificationPrompt';
export { default as AdditionalOperations, type TOperationProps } from './AdditionalOperations';
export * from './AdverseMedia';
export { default as Alert } from './Alert';
export { default as AssociatedPartiesPanel } from './AssociatedPartiesPanel';
export {
  AuthenticatorCodeInput,
  type AuthenticatorCodeInputProps,
} from './AuthenticatorCodeInput/AuthenticatorCodeInput';
export { BrandedDotLoader, type BrandedDotLoaderProps } from './BrandedDotLoader/BrandedDotLoader';
export * from './Button';
export * from './CardContainer';
export { default as Carousel } from './Carousel';
export { default as CircleLabel } from './CircleLabel';
export {
  ClarityNotice,
  type ClarityNoticeProps,
  type ClarityNoticeSeverity,
} from './ClarityNotice/ClarityNotice';
export {
  ErrorBoundaryScreen,
  type ErrorBoundaryScreenProps,
  type ErrorBoundaryAction,
} from './ErrorBoundaryScreen/ErrorBoundaryScreen';
export * from './Confidence';
export { default as Confirmation, type TConfirmation } from './Confirmation';
export { default as ContentDetailsDisplay } from './ContentDetailsDisplay';
export { default as CopyableText } from './CopyableText';
export { default as CustomerContact } from './CustomerContact';
export { default as DataGrid } from './DataGrid';
export type { TDataGridColumns, TDataGridProps, TDataGridRows } from './DataGrid';
export { default as DataTable } from './DataTable/DataTable';
export type { TDataTable } from './DataTable/DataTable';
export { default as TableCell } from './DataTable/TableCell';
export { default as DateDisplay } from './DateDisplay';
export { DesktopQrReveal, type DesktopQrRevealProps } from './DesktopQrReveal/DesktopQrReveal';
export { default as DisplayAddress } from './DisplayAddress';
export { AddressAutocomplete } from './Form/AddressAutocomplete';
export { addressAutocompleteSchema } from './Form/AddressAutocomplete/schema';
export type { AddressAutocompleteProps, Suggestion } from './Form/AddressAutocomplete/types';
export { default as DocumentNotFound } from './DocumentNotFound';
export { default as DocumentNotSupported } from './DocumentNotSupported';
export * from './DocumentRequirementsList';
export * from './DocumentTypeSelection';
export { default as EmailInputWithContinueButton } from './EmailInputWithContinueButton';
export * from './EntityPill';
export * from './EntityPlanPanel';
export * from './EntityTypeSelector';
export { ExpiryClock, type ExpiryClockProps } from './ExpiryClock/ExpiryClock';
export * from './FaceLiveness';
export { default as FavIcons } from './FavIcons';
export { default as FileDragAndDropSelector } from './FileDragAndDropSelector';
export { default as FileSelector } from './FileSelector';
export * from './FileUploader';
export { default as FlexBox } from './FlexBox';
export { default as FlexPaper } from './FlexPaper';
export { default as GlobalStyleOverride } from './GlobalStyleOverride';
export { default as Group } from './Group';
export {
  default as HeadWithContentSecurityPolicy,
  type THeadProps,
} from './HeadWithContentSecurityPolicy';
export { useHideDocumentScrollbar } from './Hooks/useHideDocumentScrollbar';
export { usePaginationModel } from './Hooks/usePaginationModel';
export { IconLink } from './IconLink';
export { IconLinkOpenNew } from './IconLinkOpenNew';
export {
  CarouselIdentityCards,
  CompactIdentityCard,
  CreateNewIdentity,
  IdentityCard,
  IdentityCards,
  IdentityStatus,
  IdentityStatusChip,
  IdentityType,
  type IdentityCardProps,
  type IdentityCardsProps,
} from './Identities';
export {
  IdentityRequirementSummary,
  type IdentityRequirementSummaryProps,
  type IdentityRequirementGroup,
  type IdentityRequirementItem,
} from './IdentityRequirementSummary/IdentityRequirementSummary';
export * from './IdScanComplete';
export * from './CompanyLogoAndName';
export {
  default as InformationDisplay,
  type TInformationDisplayProps,
  type TInformationDisplayRows,
  type TInformationItemDisplay,
} from './InformationDisplay';
export { default as Instruction } from './Instruction';
export { default as InvalidLink } from './InvalidLink';
export {
  default as InviteCustomer,
  InviteCustomerDisplayVariant,
  type TInviteCustomerProps,
} from './InviteCustomer';
export { default as KYC, type TKycRow, type TKycRows } from './KYC';
export {
  default as IndividualDetails,
  type TIndividualDetailsProps,
} from './IndividualDetails/IndividualDetails';

export {
  default as KycWithDocumentNames,
  type TExtractedNamePart,
  type TKycNameDisplay,
  type TKycWithDocumentNamesRow,
  type TKycWithDocumentNamesRows,
} from './KycWithDocumentNames';

export * from './KycWithNames';
export { default as Landing } from './Landing';
export { LinkSent, type LinkSentProps } from './LinkSent/LinkSent';
export { computeLinkExpiry, MAGIC_LINK_LIFETIME_SECONDS } from './LinkSent/linkExpiry';
export { LinkSentResend, type LinkSentResendProps } from './LinkSent/LinkSentResend';
export {
  LinkSentSignInResend,
  type LinkSentSignInResendProps,
} from './LinkSent/LinkSentSignInResend';
export {
  LoadingScreen,
  type LoadingScreenLayout,
  type LoadingScreenProps,
} from './LoadingScreen/LoadingScreen';
export * from './Logo';
export {
  MagicLinkContinue,
  type MagicLinkContinueProps,
} from './MagicLinkContinue/MagicLinkContinue';
export {
  buildIdentityRequirementGroups,
  buildDesktopCameraGroup,
} from './MagicLinkCopy/buildIdentityRequirementGroups';
export {
  LINK_REPLACEMENT_WARNING,
  RESEND_NOW_MESSAGE,
  LINK_SENT_TAIL,
} from './MagicLinkCopy/linkSentCopy';
export * from './PageShell';
export {
  fileSizeDisplay,
  default as MultiFileUploader,
  type TExistingUploadedFile,
} from './MultiFileUploader';
export type {
  TFilesUploadStatus,
  TFileToDelete,
  TFileUploadResult,
  TFileUploadStatus,
  TFileUploadUrl,
  DocumentUploaderServiceCallsProps,
} from './MultiFileUploader';
export { default as useDocumentUploader } from './MultiFileUploader/useDocumentUploader';
export { default as NameValueDisplay } from './NameValueDisplay';
export { default as HomeLink } from './Nav/HomeLink';
export { default as SideNav, type TBasicSideNavProps } from './Nav/SideNav';
export { default as SideNavLogo } from './Nav/SideNavLogo';
export { default as TopBarV2 } from './Nav/TopBarV2';
export { default as NoDataFound } from './NoDataFound';
export { default as NonSSRWrapper } from './NonSSRWrapper';
export {
  default as OrganisationSearchAutoComplete,
  type TOrganisationSearchAutoCompleteProps,
} from './Organisation/OrganisationSearchAutoComplete';
export { default as OrganisationSelection } from './Organisation/OrganisationSelection';
export {
  default as OrganisationSwitcher,
  type TOrganisationSwitcherProps,
} from './OrganisationSwitcher';
export * from './OrganisationUserManagement';
export {
  InitialCredentialSetup,
  OTPSettings,
  default as PasswordlessLogin,
  SetupAuthenticatorApp,
} from './PasswordlessLogin';
export type {
  TInitialCredentialSetupProps,
  TLoginProps,
  TSetupAuthenticatorAppProps,
} from './PasswordlessLogin';
export { default as PEP } from './PEP';
export * from './Permission';
export * from './PermissionRequest';
export { default as PrivacyPolicyLinkWithIcon } from './PrivacyPolicyLinkWithIcon';
export * from './RecoverInvitation';
export {
  default as PermissionBlock,
  type TPermissionBlockProps,
} from './PermissionBlock/PermissionBlock';
export {
  default as RequestLinkAction,
  type TRequestLinkActionProps,
  type TClipboardAvailability,
} from './RequestLinkAction/RequestLinkAction';
export {
  default as RequestLinkSlot,
  type TRequestLinkSlotProps,
} from './RequestLinkAction/RequestLinkSlot';
// The resolver is exported; the copy it returns is not. A view composes the request button itself,
// because it owns the click handler and the variant, so it needs the label and the data attribute.
// `NO_OUTSTANDING_REQUESTS` stays internal for the reason the confidence copy tables do: exporting a
// string invites a call site to render it somewhere the component does not control.
export { requestActionCopy, type TRequestActionCopy } from './RequestLinkAction/requestCopy';
export * from './RedactedCustomer';
export {
  ReportDownloadPage,
  type ReportDownloadPageProps,
  type ReportDownloadPhase,
  type ReportDownloadErrorKind,
} from './ReportDownloadPage/ReportDownloadPage';
export * from './ReportRequestedModal';
export * from './ScanIdentityDocument';
export * from './SubmissionComplete';
export * from './VerificationRequestedBy';
export { default as ActionsButton, type TActions, type SemanticColorSpec } from './ActionsButton';
export * from './ColoredIconAndChip';
export { default as SearchAutocomplete } from './ComboBox';
export { default as ConfirmAndCancel } from './ConfirmAndCancel';
export * from './ConsentFooterContent';
export { default as Declaration } from './Declaration';
export * from './DvsStatus';
export { default as EmailInput } from './EmailInput';
export { default as FeatureToggleList } from './FeatureToggleList';
export * from './Form';
export * from './IdentityDocumentPhotoGuide';
export * from './IndividualPortrait';
export * from './material-ui-confirm';
export * from './Notification';
export * from './Organisation/OrganisationCode';
export * from './PasswordlessLogin';
export { default as PrivacyPolicyLink } from './PrivacyPolicyLink';
export { default as ResponsiveBox } from './ResponsiveBox';
export { default as Risk } from './Risk';
export { default as RiskLevelChip } from './Risk/RiskLevelChip';
export * from './Risk/types';
export * from './Search';
export { default as Search } from './Search';
export * from './SearchFeature';
export { secureDownload, SecureDownloadError } from './secureDownload';
export * from './SandboxedFileViewer';
export { default as SearchItemDisplay } from './SearchItemDisplay';
export { default as SelectItemDrawer } from './SelectItemDrawer/SelectItemDrawer';
export {
  ShowScanQualityIssues,
  type TScanQualityCheck,
  type TShowScanQualityIssuesProps,
} from './ShowScanQualityIssues';
export * from './Status';
export { StatusIconTile, type StatusIconTileProps } from './StatusIconTile/StatusIconTile';
export {
  StatusKnockoutTile,
  type StatusKnockoutTileProps,
} from './StatusKnockoutTile/StatusKnockoutTile';
export { default as StepsWizard } from './StepsWizard';
export type {
  TConfirmationAction,
  TMemoizedObj,
  TStep,
  TStepContent,
  TStepHeader,
  TStepNumber,
  TSteps,
} from './StepsWizard';
export { default as StepWrapper } from './StepWrapper';
export {
  EntityInitialsAvatar,
  type EntityInitialsAvatarProps,
  type RequestIdentityState,
} from './RequestScreens/EntityInitialsAvatar/EntityInitialsAvatar';
export { toEntityInitials } from './RequestScreens/EntityInitialsAvatar/toEntityInitials';
export {
  IdentityTypeRow,
  toNewIdentityId,
  type IdentityTypeRowIdentity,
  type IdentityTypeRowProps,
} from './RequestScreens/IdentityTypeRow/IdentityTypeRow';
export { InfoFootnote, type InfoFootnoteProps } from './RequestScreens/InfoFootnote/InfoFootnote';
export {
  NewIdentityCard,
  type NewIdentityCardProps,
} from './RequestScreens/NewIdentityCard/NewIdentityCard';
export {
  RequestBannerStepper,
  type RequestBannerStepperCopy,
  type RequestBannerStepperCopyOverrides,
  type RequestBannerStepperProps,
} from './RequestScreens/RequestBannerStepper/RequestBannerStepper';
export {
  RequestChooseScreen,
  type RequestChooseScreenCopy,
  type RequestChooseScreenCopyOverrides,
  type RequestChooseScreenHeldType,
  type RequestChooseScreenProps,
  type RequestPrimaryAction,
} from './RequestScreens/RequestChooseScreen/RequestChooseScreen';
export { REQUEST_CHOOSE_LIMIT_NOTE } from './RequestScreens/RequestChooseScreen/requestChooseScreenCopy';
export {
  RequestIdentityCard,
  type RequestIdentityCardProps,
  type RequestIdentityStatusLabels,
} from './RequestScreens/RequestIdentityCard/RequestIdentityCard';
export {
  DismissRequestDialog,
  type DismissRequestDialogCopy,
  type DismissRequestDialogCopyOverrides,
  type DismissRequestDialogProps,
} from './RequestScreens/DismissRequestDialog/DismissRequestDialog';
export {
  TypedRequestCard,
  type TypedRequestCardCopy,
  type TypedRequestCardCopyOverrides,
  type TypedRequestCardMenuItem,
  type TypedRequestCardProps,
} from './RequestScreens/TypedRequestCard/TypedRequestCard';
export { StickyActionBar } from './StickyActionBar/StickyActionBar';
export type { StickyActionBarProps } from './StickyActionBar/StickyActionBar';
export { default as SelectDocumentToUploadDrawer } from './SupportDocuments/SelectDocumentToUploadDrawer';
export { default as SupportDocumentDetailsView } from './SupportDocuments/SupportDocumentDetailsView';
export { default as UploadForVerification } from './SupportDocuments/UploadForVerification';
export * from './SupportDocuments/utils';
export { default as TaskRequestPanel, type TTaskRequestPanelProps } from './TaskRequestPanel';
export { default as TermsOfUseLink } from './TermsOfUseLink';
export { default as TextEditor } from './TextEditor';
export * from './ThrottledResend';
export * from './Thumbnail';
export { default as Title } from './Title';
export {
  IdentityDocumentType,
  default as TrafficLight,
  type TTrafficLightData,
  type TTrafficLightDataItem,
  type TTrafficLightDocumentData,
  type TTrafficLightFacecheckData,
  type TTrafficLightOperations,
  type TTrafficLightStatus,
} from './TrafficLight';
export * from './types';
export { default as UserCredentialStatus } from './UserCredentialStatus';
export * from './utils';
export { default as VerificationStatus } from './VerificationStatus';
export { default as WholesaleCertificate } from './WholesaleCertificate';
export * from './XpmIntegration';
export { GoogleSsoSignUpForm, type TGoogleSsoSignUpFormProps } from './GoogleSsoSignUp';

/**
 * Material-UI Theme Extensions for VerifiMe Design System
 *
 * This module augments MUI's theme types with VerifiMe's semantic color system
 * and contextual tokens following the 3-tier token architecture.
 *
 * @see ADR 0078: Contextual Semantic Tokens for Component Styling
 * @see Token Usage Guidelines: /doc/guidelines/token-usage-guidelines.md
 *
 * Architecture:
 * - Tier 1: Primitive tokens (clarityTokens.*) - Only in theme files
 * - Tier 2: Semantic tokens (theme.spacing.*, theme.sizing.*) - Generic purpose
 * - Tier 3: Contextual tokens (theme.card.*, theme.logo.*) - Use-case specific
 */
declare module '@mui/material/styles' {
  interface SimplePaletteColorOptions {
    lighter?: string;
    darker?: string;
    stroke?: string;
  }
  interface PaletteColor {
    lighter?: string;
    darker?: string;
    stroke?: string;
  }

  interface TypeText {
    permanentBlack: string;
    permanentWhite: string;
    tertiary: string;
    /**
     * Success tone for *text and inline icons drawn directly on a surface*, as opposed to
     * `status.success`, whose `text` is the contrasting colour used on top of a success fill.
     *
     * Deliberately not `success.main`. That is the fill colour, and a fill colour is chosen to
     * carry white text rather than to be read against paper: measured against the dark theme's
     * paper it lands near 2.9:1, well under the 4.5:1 that normal-size text needs. This token is
     * the 500 step on light and the 300 step on dark, which clear the bar on both.
     */
    success: string;
    /**
     * Danger tone for text and inline icons drawn directly on a surface. The counterpart to
     * {@link TypeText.success}, and named `danger` to match `surface.dangerSubtle` rather than
     * `error`, which in this palette denotes the fill.
     *
     * `error.main` is the worse of the two against dark paper, near 2.4:1.
     */
    danger: string;
  }

  /**
   * Colours that hold their hue across light and dark rather than tracking mode, the same
   * "always this, never mode-shifted" intent as {@link TypeText.permanentBlack} and
   * {@link TypeText.permanentWhite}, but for the brand hue rather than monochrome.
   *
   * There is no permanent numbered ramp on this palette: `primary.main` lightens from Eggplant
   * 500 (light) to Eggplant 300 (dark) by design, so a caller that needs the brand purple to hold
   * (an icon on a countdown, for example, where a lighter mode-tracked purple reads as disabled)
   * has no other path to it. Follows the precedent set by `risk.high.fill`, which repeats the
   * same numbered gradation in both theme files rather than introducing a dedicated token; this
   * does the same for the brand ramp instead of a status ramp.
   */
  interface Permanent {
    primary: string;
    /**
     * The permanent danger red used by StatusKnockoutTile: both of the board's failure states
     * (1c/1c wa's ErrorFilled and 1d's InfoFilled) render in the same red regardless of light/dark
     * mode, per C4's ruling that a grey "neutral" treatment would invent a severity the design
     * does not have. Declared via merging into this interface, not a fresh inline shape, so it
     * joins `primary` on the same `Permanent` type both theme files already implement.
     */
    danger: string;
  }

  /**
   * Semantic color object for status, risk, entity, and interactive states.
   *
   * Usage patterns by context:
   *
   * **Standalone Icons** (StatusIcon, ColoredIcon):
   * - Use `fill || icon` to display main color
   * - Example: `sx={{ fill: color?.fill || color?.icon }}`
   * - Result: Green checkmark icon with green background
   *
   * **Chip Icons** (icons inside StatusChip, ColoredChip):
   * - Use `icon || text` for contrasting color on colored background
   * - Example: `sx={{ fill: color?.icon || color?.text }}`
   * - Result: White icon on green chip background
   *
   * **Chip Background**:
   * - Use `fill` for main background color
   * - Example: `bgcolor: color?.fill`
   *
   * **Chip Text**:
   * - Use `text` for color that contrasts with background
   * - Example: `color: color?.text`
   *
   * **Borders**:
   * - Use `border` for outlined variants
   * - Example: `border: 1px solid ${color?.border}`
   *
   * @property {string} text - Text color that contrasts with fill background
   * @property {string} [fill] - Main background/fill color for chips and standalone icons
   * @property {string} [border] - Border color for outlined variants
   * @property {string} [icon] - Icon color for contrast on colored backgrounds
   *
   * @example
   * // Standalone icon - uses fill for main color
   * <ColoredIcon iconName="checkCircle" sx={{ fill: color?.fill || color?.icon }} />
   *
   * @example
   * // Chip with icon - icon uses contrasting color, background uses fill
   * <ColoredChip
   *   icon={<ColoredIcon iconName="checkCircle" sx={{ fill: color?.icon || color?.text }} />}
   *   statusColor={color}
   *   label="Success"
   * />
   */
  type StatusColor = {
    text: string;
    fill?: string;
    border?: string;
    icon?: string;
  };

  /**
   * Semantic color palettes organized by context.
   *
   * **Tier 2 Semantic Tokens**: Status colors for component states
   * - `status.*` - Generic success/warning/error/info states
   * - `interactive.*` - Interactive element states (disabled/enabled)
   * - `risk.*` - Risk assessment levels (extreme/high/medium/low/pending)
   * - `confidence.*` - Identity-confidence ladder tones (none/pending/low/substantial/high)
   * - `entity.*` - Entity verification states (verified/rejected/draft/inProgress/empty)
   *
   * All color objects use StatusColor type with consistent properties:
   * - `text`: Contrasting text color
   * - `fill`: Main background/fill color
   * - `border`: Border color (optional)
   * - `icon`: Icon color for contrast (optional)
   *
   * @see StatusColor type documentation for usage patterns
   */
  interface Palette {
    permanent: Permanent;
    surface: {
      logo: string;
      /** Pale brand-colour wash; Eggplant 050 (light) / Eggplant 900 (dark). */
      brandSubtle: string;
      /** Pale success wash; Green 050 (light) / Green 900 (dark). */
      successSubtle: string;
      /** Pale danger wash; Red 050 (light) / Red 900 (dark). */
      dangerSubtle: string;
      /** Pale warning wash; Yellow 050 (light) / Yellow 900 (dark). */
      warningSubtle: string;
      /** Pale neutral wash; Grey 050 (light) / Grey 900 (dark). */
      neutralSubtle: string;
      /**
       * An interactive neutral surface one step raised from `neutralSubtle`; Grey 050 (light,
       * same primitive as `neutralSubtle`) / Grey 800 (dark). Light has no separate "raised"
       * treatment on the artboard, so it shares `neutralSubtle`'s value rather than inventing one.
       */
      neutralSubtleRaised: string;
    };
    border: {
      decorative: string;
      /**
       * A 1px card border, Eggplant 200 (light). Named `subtleAccent` rather than a hue-specific
       * name because it does not hold a hue across modes the way the other `*Subtle` tokens do:
       * measured directly off the artboard's dark card, the dark value is Grey 700, a neutral
       * rather than a darker step of the same brand tint.
       */
      subtleAccent: string;
    };
    status: {
      success: StatusColor;
      warning: StatusColor;
      error: StatusColor;
      info: StatusColor;
    };
    interactive: {
      disabled: StatusColor;
      enabled: StatusColor;
    };
    risk: {
      extreme: StatusColor;
      high: StatusColor;
      medium: StatusColor;
      low: StatusColor;
      pending: StatusColor;
    };
    /**
     * Identity-confidence tones for the KYC confidence ladder.
     *
     * Deliberately separate from `risk.*`, which is a different axis on a different scale: a
     * confidence tone and a risk level that share a name do not share a meaning, and reusing the
     * risk palette here would couple two vocabularies that diverge the moment either is restyled.
     *
     * `none` is the unfilled step and `pending` is a filled but uncoloured step, which is what
     * distinguishes "the check ran and returned nothing yet" from "the check has not started".
     * Tone and fill count are independent: a level can fill one step in `pending` or in `low`.
     *
     * The names are the prototype's own tone vocabulary, not level names and not risk names.
     */
    confidence: {
      none: StatusColor;
      pending: StatusColor;
      low: StatusColor;
      substantial: StatusColor;
      high: StatusColor;
      /** Fill and text for the "what do you do now" box, `ConfidenceGuidance`. */
      guidance: { fill: string; text: string };
    };
    /**
     * Overlay tones for controls drawn on top of media rather than on a page surface.
     *
     * Identical in light and dark, and deliberately so: these sit over an arbitrary video frame,
     * not over `background.paper`, so the thing they need contrast against is the customer's
     * capture and not the theme. Flipping them with the theme would make them *less* legible on
     * half the frames they land on.
     */
    mediaOverlay: {
      /** Base of the gradient behind the control bar, fading to transparent upwards. */
      scrim: string;
      /** Fill behind a control button. */
      control: string;
      /** Fill behind a control button on hover. */
      controlHover: string;
      /** Unfilled portion of the playback progress track. */
      track: string;
      /** Ring around the progress thumb on hover and keyboard focus. */
      halo: string;
    };
    entity: {
      verified: StatusColor;
      rejected: StatusColor;
      draft: StatusColor;
      inProgress: StatusColor;
      empty: StatusColor;
    };
  }
  interface PaletteOptions {
    permanent?: Partial<Permanent>;
    surface?: {
      logo?: string;
      brandSubtle?: string;
      successSubtle?: string;
      dangerSubtle?: string;
      warningSubtle?: string;
      neutralSubtle?: string;
      neutralSubtleRaised?: string;
    };
    border?: {
      decorative?: string;
      subtleAccent?: string;
    };
    status?: Partial<Palette['status']>;
    interactive?: Partial<Palette['interactive']>;
    risk?: Partial<Palette['risk']>;
    confidence?: Partial<Palette['confidence']>;
    mediaOverlay?: Partial<Palette['mediaOverlay']>;
    entity?: Partial<Palette['entity']>;
  }

  /**
   * Theme interface with VerifiMe's 3-tier token architecture.
   *
   * **Token Tiers**:
   *
   * **Tier 2: Semantic Tokens** (Generic purpose)
   * - `semantic.spacing.*` - Generic spacing scale (xs, sm, base, lg, xl, etc.)
   * - `semantic.size.*` - Generic sizing scale
   * - `semantic.borderRadius.*` - Generic border radius values
   * - `semantic.fontWeight.*` - Font weight scale
   * - `semantic.fontSize.*` - Font size scale
   * - `semantic.letterSpacing.*` - Letter spacing values
   * - `semantic.lineHeight.*` - Line height values
   *
   * **Usage**: For generic spacing/sizing needs without specific use-case context
   *
   * **Tier 3: Contextual Tokens** (Use-case specific)
   * - `logo.*` - Logo component styling (width, padding, borderRadius)
   * - `card.*` - Card/Paper component styling (padding, borderRadius, gaps, borders)
   *
   * **Usage**: For components following established design patterns
   *
   * @see ADR 0078: Contextual Semantic Tokens for Component Styling
   * @see Token Usage Guidelines for token selection decision tree
   *
   * @example
   * // Tier 2: Generic spacing
   * <Box sx={(theme) => ({ gap: theme.semantic.spacing.base })}>
   *
   * @example
   * // Tier 3: Contextual token
   * <Paper sx={(theme) => ({ padding: theme.card.padding })}>
   *
   * Note: All properties are required to ensure type safety across theme switching.
   */
  interface Theme {
    semantic: {
      spacing: {
        none: string;
        '4xs': string;
        '3xs': string;
        '2xs': string;
        xs: string;
        sm: string;
        base: string;
        lg: string;
        '2lg': string;
        xl: string;
        '2xl': string;
        '3xl': string;
        '4xl': string;
        '5xl': string;
        '6xl': string;
        '7xl': string;
      };
      size: {
        '8xs': string;
        '7xs': string;
        '6xs': string;
        '5xs': string;
        '4xs': string;
        '3xs': string;
        '2xs': string;
        xs: string;
        sm: string;
        md: string;
        lg: string;
        xl: string;
      };
      borderRadius: {
        sm: string;
        lg: string;
        xl: string;
        round: string;
      };
      fontWeight: {
        light: string;
        regular: string;
        semibold: string;
        bold: string;
        bolder: string;
      };
      fontSize: {
        xs: string;
        sm: string;
        base: string;
        lg: string;
        l: string;
        xl: string;
        '2xl': string;
        '3xl': string;
        '4xl': string;
        '5xl': string;
        '6xl': string;
        '7xl': string;
        '8xl': string;
      };
      letterSpacing: {
        xs: string;
        sm: string;
        reg: string;
        lg: string;
        xl: string;
      };
      lineHeight: {
        single: string;
        short: string;
        long: string;
        double: string;
        standard: string;
      };
    };
    /**
     * Logo component contextual tokens.
     *
     * @example
     * <Box sx={(theme) => ({
     *   width: theme.logo.width,
     *   padding: theme.logo.padding,
     *   borderRadius: theme.logo.borderRadius,
     * })}}>
     */
    logo: {
      width: string;
      padding: string;
      borderRadius: string;
    };
    /**
     * Card/Paper component contextual tokens.
     *
     * @property padding - Standard card padding
     * @property borderRadius - Card corner radius
     * @property borderWidth - Card border thickness
     * @property contentGap - Gap between major card sections
     * @property itemGap - Gap between related items within sections
     *
     * @example
     * <Paper sx={(theme) => ({
     *   padding: theme.card.padding,
     *   borderRadius: theme.card.borderRadius,
     * })}>
     *   <Box sx={(theme) => ({ display: 'flex', gap: theme.card.itemGap })}>
     */
    card: {
      padding: string;
      borderRadius: string;
      borderWidth: string;
      contentGap: string;
      itemGap: string;
    };
    /**
     * Request-screen identity card contextual tokens (Clarity brand only, like `notice`).
     *
     * @property width - Fixed card width
     * @property height - Fixed card height, so a row of cards has one fixed height
     * @property avatarSize - Diameter of the initials avatar
     * @property optionRowMaxWidth - Widest the phone "verify a new" option row grows
     * @property unavailableOpacity - Opacity of an identity already shared with the provider
     * @property stateTransitionDuration - Time a card takes to shift colour on hover and press
     * @property hoverBackground - Background of an unchosen card under the pointer
     * @property hoverBorder - Hairline border colour of an unchosen card under the pointer
     * @property activeBackground - Background of an unchosen card while pressed
     *
     * @example
     * <Box sx={(theme) => ({ width: theme.identityCard.width, height: theme.identityCard.height })}>
     */
    identityCard: {
      width: string;
      height: string;
      avatarSize: string;
      optionRowMaxWidth: string;
      unavailableOpacity: number;
      stateTransitionDuration: string;
      hoverBackground: string;
      hoverBorder: string;
      activeBackground: string;
    };
    /**
     * Request-screen action button contextual tokens (Clarity brand only, like `identityCard`).
     *
     * @property buttonHeight - Height of the request screens' buttons: the choose screen's Cancel and
     * primary, the Home banner's buttons, the request card's primary and the dismissal dialog's buttons
     *
     * @example
     * <Button sx={(theme) => ({ minHeight: theme.requestActions.buttonHeight })}>
     */
    requestActions: {
      buttonHeight: string;
    };
    /**
     * Home request banner contextual tokens (Clarity brand only, like `requestActions`).
     *
     * @property counterFontFamily - Font family of the "n of m" counter (the board's IBM Plex Mono,
     * then the system monospace faces)
     * @property dotSize - Diameter of a stepping dot
     * @property edgeDotSize - Diameter of a stepping dot at the end of the window while more
     * requests lie beyond it
     * @property stateTransitionDuration - Time a dot or step button takes to shift colour on hover
     * @property dotColor - Colour of a stepping dot that is not the current request
     * @property stepHoverBackground - Background of a back or next button under the pointer
     *
     * @example
     * <Box sx={(theme) => ({ fontFamily: theme.requestBanner.counterFontFamily })}>
     */
    requestBanner: {
      counterFontFamily: string;
      dotSize: string;
      edgeDotSize: string;
      stateTransitionDuration: string;
      dotColor: string;
      stepHoverBackground: string;
    };
    /**
     * Request card contextual tokens (Clarity brand only, like `requestBanner`).
     *
     * @property menuButtonSize - Diameter of the round menu button at the card's top right
     *
     * @example
     * <IconButton sx={(theme) => ({ width: theme.requestCard.menuButtonSize })}>
     */
    requestCard: {
      menuButtonSize: string;
    };
    /**
     * Dismissal dialog contextual tokens (Clarity brand only, like `requestCard`).
     *
     * @property width - Width of the dialog from the `md` breakpoint up
     *
     * @example
     * <Paper sx={(theme) => ({ width: theme.requestDialog.width })}>
     */
    requestDialog: {
      width: string;
    };
    /**
     * Notice/alert banner contextual tokens.
     *
     * Each severity variant defines background and foreground colours pulled
     * from the relevant clarity theme file (Tier 1 primitives resolved at
     * theme build time). Components read these values via the theme object
     * rather than accessing clarityTokens directly.
     *
     * Extensible: add success/warning entries here and in both theme files
     * when required, following the same shape.
     *
     * @example
     * <Box sx={(theme) => ({
     *   backgroundColor: theme.notice[severity].background,
     *   color: theme.notice[severity].foreground,
     * })}>
     */
    notice: {
      info: { background: string; foreground: string };
      danger: { background: string; foreground: string };
    };
  }
  interface ThemeOptions {
    semantic?: {
      spacing?: {
        none?: string;
        '4xs'?: string;
        '3xs'?: string;
        '2xs'?: string;
        xs?: string;
        sm?: string;
        base?: string;
        lg?: string;
        '2lg'?: string;
        xl?: string;
        '2xl'?: string;
        '3xl'?: string;
        '4xl'?: string;
        '5xl'?: string;
        '6xl'?: string;
        '7xl'?: string;
      };
      size?: {
        '8xs'?: string;
        '7xs'?: string;
        '6xs'?: string;
        '5xs'?: string;
        '4xs'?: string;
        '3xs'?: string;
        '2xs'?: string;
        xs?: string;
        sm?: string;
        md?: string;
        lg?: string;
        xl?: string;
      };
      borderRadius?: {
        sm?: string;
        lg?: string;
        xl?: string;
        round?: string;
      };
      fontWeight?: {
        light?: string;
        regular?: string;
        semibold?: string;
        bold?: string;
        bolder?: string;
      };
      fontSize?: {
        xs?: string;
        sm?: string;
        base?: string;
        lg?: string;
        l?: string;
        xl?: string;
        '2xl'?: string;
        '3xl'?: string;
        '4xl'?: string;
        '5xl'?: string;
        '6xl'?: string;
        '7xl'?: string;
        '8xl'?: string;
      };
      letterSpacing?: {
        xs?: string;
        sm?: string;
        reg?: string;
        lg?: string;
        xl?: string;
      };
      lineHeight?: {
        single?: string;
        short?: string;
        long?: string;
        double?: string;
        standard?: string;
      };
    };
    logo?: {
      width?: string;
      padding?: string;
      borderRadius?: string;
    };
    card?: {
      padding?: string;
      borderRadius?: string;
      borderWidth?: string;
      contentGap?: string;
      itemGap?: string;
    };
    identityCard?: {
      width?: string;
      height?: string;
      avatarSize?: string;
      optionRowMaxWidth?: string;
      unavailableOpacity?: number;
      stateTransitionDuration?: string;
      hoverBackground?: string;
      hoverBorder?: string;
      activeBackground?: string;
    };
    requestActions?: {
      buttonHeight?: string;
    };
    requestBanner?: {
      counterFontFamily?: string;
      dotSize?: string;
      edgeDotSize?: string;
      stateTransitionDuration?: string;
      dotColor?: string;
      stepHoverBackground?: string;
    };
    requestCard?: {
      menuButtonSize?: string;
    };
    requestDialog?: {
      width?: string;
    };
    notice?: {
      info?: { background?: string; foreground?: string };
      danger?: { background?: string; foreground?: string };
    };
  }
}
